export const DEFAULT_COUNTRY = "US"

export const DEFAULT_VISIT_DURATION = 90

export const DEBOUNCE_TIME = 800

export const DEFAULT_PLACEHOLDER = "--"

export const GENERIC_ERROR_MESSAGE =
	"An unexpected error occurred. Please, try again."

export const ICD10_QUERY_MIN_LENGTH = 2

export const KG_TO_LBS = 2.2046

export const ORG_HEADER_KEY = "select-care-organization-id"

export const PERSISTENCE_USER_INFO_KEY = "user_state"

export const DEFAULT_TIMEZONE = "America/New_York"
